import { Component } from 'react';

import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

import CumulativeDataChart from '../../../../components/Charts/CumulativeDataChart';
import chartsGuide from '../../../../utils/charts/charts_guide.json';

// https://apexcharts.com/react-chart-demos/line-charts/brush-chart/
// https://apexcharts.com/react-chart-demos/area-charts/github-style/

// TODO : Missing bar for cumulative

interface Props {
    loading: boolean
    data?: any
}
interface State {
}

export default class CumulativeStatistics extends Component<Props, State>{


    render() {
        return (
            <div className="ingestion-statistics">
                <div className="date-charts">
                    {
                        this.props.loading ?
                            <div className="centered"><Spinner /></div>
                            :
                            this.props.data ?
                                <>
                                    <CumulativeDataChart
                                        title="Archived products size"
                                        data={this.props.data.cum[0]}
                                        size
                                        chartData={chartsGuide.online_missions_chart}
                                    />
                                    <CumulativeDataChart
                                        title="Archived products number"
                                        data={this.props.data.cum[1]}
                                        chartData={chartsGuide.online_missions_chart}
                                    />
                                </> 
                                :
                                <div className="no-data">No data</div>
                    }
                </div>
            </div>
        );
    }

};
